<div class="border-card border-0 px-4 py-1 scroll-container" ref="manage_workflow">
  <NavigationBackButton />

  <div class="card-header card-header-primary shadow-2 rounded-lg mt-3">
    <div class="nav-tabs-navigation">
      <div class=" nav nav-tabs-wrapper">
        <p class="p-2 text-white mb-0 text-x fw-bold">Requested Information From {{requester_name}}</p>
      </div>
    </div>
  </div>
  <div class="card rounded-lg border-0 shadow-sm mt-2">

    <div class="card-body rounded-lg">
      <!-- Message Card -->
      <div class="card mb-3 border-0 shadow-sm hover-card gray-background shadow-sm">
        <div class="card-body px-3 py-2  shadow-sm">
          <p class="text-x mt-3">{{ request_note }}</p>
          <div class="text-end text-xxs text-muted">{{ date_requested }}</div>
        </div>
      </div>

      <!-- Documents Card -->

      <div v-if="has_submitted_response" class="text-xxs mt-5">
        <div class="fw-bold mb-2">Submitted response</div>

        <div class="d-flex border rounded-top p-2 card-bg text-white">
          <div class="col-1">No</div>
          <div class="col-2">Document Name</div>
          <div class="col-3">Date Uploaded</div>
          <div class="col-4">Review Status</div>
          <div class="col-5">Action</div>
        </div>

        <div
          v-for="(doc, index) in submitted_response"
          :key="index"
          class="document-row d-flex border-start border-end border-bottom p-2 align-items-center"
          :class="{ 'rounded-bottom': index === submitted_response.length - 1 }"
        >
          <div class="col-1">{{ index + 1 }}</div>
          <div class="col-4 text-truncate">{{ doc.document_name }}</div>
          <div class="col-3">{{ doc.date_created }}</div>
          <div class="col-2">
            <span
              class="badge px-2 py-1"
              :class="{
                'bg-success text-white': doc.response_accepted,
                'bg-danger text-white': doc.response_rejected,
                'bg-secondary text-white': !doc.response_accepted && !doc.response_rejected
              }"
            >
              {{ doc.review_status }}
            </span>
          </div>
          <div class="col-2">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm text-xxs shadow"
              @click="open_document(doc)"
            >
              View
            </button>
          </div>
        </div>
      </div>
      <div
        v-if="fields.length && (!has_submitted_response || has_rejected_response)"
        class="card mt-4 border-2 shadow-sm"
      >
        <div class="card-body px-3 py-2">

          <div
            v-if="has_rejected_response"
            class="alert alert-danger text-xxs mb-3"
          >
            One or more uploaded documents were rejected. Please upload corrected files.
          </div>

          <div
            class="mt-3"
            v-for="(field, index) in fields"
            :key="index"
          >
            <div class="mb-3">
              <div class="d-flex align-items-center mb-2">
                <i class="fa-regular fa-file me-2"></i>
                <label class="text-xxs">{{ field.label }}</label>
              </div>

              <input
                type="file"
                class="form-control text-xs rounded-small shadow-sm"
                @change="handle_file_change($event, index)"
              />

              <div
                v-if="file_validation_error[index]"
                class="text-danger text-xxs mt-1"
              >
                {{ file_validation_error[index] }}
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end">
            <button
              type="submit"
              class="btn btn-primary-dark btn-sm text-xxs shadow mt-3"
              @click="submit_response"
            >
              Submit
            </button>
          </div>

        </div>
      </div>
      <div v-else>
        <p class="text-xs mt-3 fw-bold">Please update the above requested fields on your application</p>
      </div>
    </div>
  </div>
</div>
<div v-if="preview_modal"  @click.self="preview_modal = false">
  <FilePreviewComponent :presigned_url="selected_file.presigned_url" @close="close_the_file_preview"
    :key="selected_file.presigned_url" />
</div>